import { Injectable } from '@angular/core';

import { Timestamp, collection, doc, setDoc, count, sum, average, getAggregateFromServer, getFirestore, deleteDoc, getDocs, where, query, documentId, getDoc, updateDoc, getDocFromCache, addDoc, orderBy, increment } from "firebase/firestore";
import moment from 'moment';
import { BehaviorSubject, Observable, defer, from, switchMap } from 'rxjs';
import { currentUserUid, ownedCollection, withCurrentOwner } from '../../../utils/firestore-ownership';


@Injectable({
  providedIn: 'root'
})
export class SharesService {

  private shares!: BehaviorSubject<any[]>;

  constructor() {
    this.shares = new BehaviorSubject<any[]>([])
  }

  public async selectAll(): Promise<void> {
    // console.log('SharesService', 'selectAll')

    const shares:any[] = []

    const q = ownedCollection('Shares');
    const allDocs = await getDocs(q)
    allDocs.docs.forEach((d:any, j:any, h:any) => {
      console.log('Doc:', d.id, 'ref:', d.ref, d.ref.path)
      
      const doc = { ...d.data(), id: d.id, ref: d.ref, path: d.ref.path }
      shares.push(doc)
    })

    this.shares.next(shares)

    // const q = query(collection(db, "cities"), where("state", "==", "CA"));
    // const unsubscribe = onSnapshot(q, (snapshot) => {
    //   snapshot.docChanges().forEach((change) => {
    //     if (change.type === "added") {
    //         console.log("New city: ", change.doc.data());
    //     }
    //     if (change.type === "modified") {
    //         console.log("Modified city: ", change.doc.data());
    //     }
    //     if (change.type === "removed") {
    //         console.log("Removed city: ", change.doc.data());
    //     }
    //   })
    // })
  }

  getAll(): Observable<any[]> {
    console.log('SharesService', 'getAll')

    return defer(() => from(this.selectAll()).pipe(switchMap(() => this.shares.asObservable())));
  }
  
  async addItem(e:any):Promise<void> {
    console.log('SharesService', 'addItem', e)

    await addDoc(collection(getFirestore(), 'Shares'), { ...withCurrentOwner(e), created_on: Timestamp.now(), modified_on: Timestamp.now() });
    // this.shares.next([e, ...this.shares.value])
    await this.selectAll()
  }

  async delete(e:any):Promise<void>{
    console.log('SharesService', 'delete', e.id)

    await deleteDoc(doc(getFirestore(), 'Shares', e.id));
    await this.selectAll();
  }

  async modify(e:any):Promise<void>{
    console.log('SharesService', 'modify', e.id)

    await updateDoc(doc(getFirestore(), 'Shares', e.id), { ...withCurrentOwner(e), modified_on: Timestamp.now() });
    await this.selectAll();
  }

  //#region forms

  async loadOptions(t:string): Promise<any[]> {
    console.log('SharesService', 'loadOptions', 'type', t)

    const _options:any[] = []
    let q
    q = query(collection(getFirestore(), 'Shares'), where('ownerUid', '==', currentUserUid()), where('type', '==', t), orderBy('code', 'asc'))

    const allDocs = await getDocs(q)
    allDocs.docs.forEach((d:any, j:any, h:any) => {      
      console.log('SharesService', 'loadOptions', 'Doc:', d.id, d.data().code)
      _options.push({ 
          code: d.data().code, 
          company: d.data().company, 
          alias: d.data().alias 
        })        
    })
    
    return _options
  }

  // Filtered client-side: a user has few shares and this avoids another composite index
  async loadDividendOptions(): Promise<any[]> {
    const allDocs = await getDocs(ownedCollection('Shares'))

    return allDocs.docs
      .map((d:any) => d.data())
      .filter((s:any) => hasDividends(s))
      .map((s:any) => ({ code: s.code, company: s.company, alias: s.alias }))
      .sort((a:any, b:any) => a.code.localeCompare(b.code))
  }

  //#endregion
}

// Shares created before the "dividends" flag existed: stocks and REITs pay dividends
export function hasDividends(share: any): boolean {
  return share.dividends ?? ['STOCK', 'REIT'].includes(share.type)
}
